import {CartItem} from '../CartItem'
import {isTouching} from '../is'
import {replaceInString} from '../replaceInString'
import {VariantDict} from '../VariantDict'

const $window = $(window)
const pathName = window.location.pathname

export function initProductItem() {
	$('.product-item').once('initProductItem').each(function () {
		const $item = $(this)
		const $image = $item.find('.product-item__image')

		const $quickAdd = $item.find('.quick-add')
		const $back = $quickAdd.find('.quick-add__back')

		const title = $item.data('productTitle')
		const fallbackImage = $item.data('fallbackImage')
		const dict = new VariantDict($item.data('variantDict'))

		const $swatch = $item.find('.product-item__swatch')
		$swatch.on('mouseover', function () {
			const $thisSwatch = $(this)
			$thisSwatch.click()
			$swatch.removeClass('product-item__swatch--active')
			$thisSwatch.addClass('product-item__swatch--active')
		})

		$item.find('.product-item__swatch-selector').each(function () {
			const $input = $(this)
			const index = $input.data('optionIndex')
			const value = $input.data('optionValue')

			$input.on('change', updateColorKey)
			if ($input.is(':checked')) {
				updateColorKey()
			}

			function updateColorKey() {
				dict.updateDefaultKey({[index]: value})
			}
		})

		$image.on('mouseenter', startQuickAdd)
		$image.on('mouseleave', stopQuickAdd)

		function startQuickAdd() {
			if (isTouching()) {
				return
			}

			$quickAdd.show()
			$back.empty()
			const variants = dict.allCurrentVariants()
			variants.forEach(variant => {
				const value = variant.option1
				const $addButton = $(`<div class="quick-add__button">${value}</div>`)

				if (variant.available) {
					$addButton.on('click', function () {
						const fullVariant = {
							product_title: title,
							...variant
						}

						if (!fullVariant.featured_image) {
							fullVariant.featured_image = {
								url: fallbackImage
							}
						}

						cart.addItem(new CartItem(fullVariant, 1))
						cart.update()

						const messageTemplate = $('body').data('quickAddToastSuccess')
						const message = replaceInString(messageTemplate, {title})
						$window.trigger('quickAdd:itemAdded', {message})

						if (pathName === '/cart') {
							setTimeout(function() {
								$window.scrollTop(0)
								location.reload()
							}, 750)
						}
					})
				} else {
					$addButton.addClass('quick-add--out-of-stock')
				}
				$back.append($addButton)
			})
		}

		function stopQuickAdd() {
			$quickAdd.hide()
		}
	})
}